/** Benchmark strip under the client reporting equity chart (matches Overview / Vector Capital). */
import { themeColor } from '../../utils/themeColor';

export const CLIENT_REPORTING_BENCHMARKS = [
  { id: 'SPY', label: 'S&P 500', shortLabel: 'SPY', accent: 'spy' },
  { id: 'QQQ', label: 'Nasdaq-100', shortLabel: 'QQQ', accent: 'qqq' },
  { id: 'IEF', label: 'US 7-10Y Treasury', shortLabel: 'IEF', accent: 'ief' },
  { id: 'GLD', label: 'Gold', shortLabel: 'GLD', accent: 'gld' },
];

export const CLIENT_REPORTING_BENCHMARK_SYMBOLS = CLIENT_REPORTING_BENCHMARKS.map((b) => b.id);

export const BENCHMARK_COMPARE_ROWS = [
  { id: 'gain', label: 'Gain', kind: 'pct' },
  { id: 'monthly', label: 'Monthly', kind: 'pct' },
  { id: 'yearly', label: 'Yearly', kind: 'pct' },
  { id: 'drawdown', label: 'Drawdown', kind: 'pct' },
  { id: 'profit', label: 'Profit', kind: 'currency' },
];

export const ACCOUNT_CHART_COLOR = '#9333ea';

export const DEFAULT_BROKER_CHART_COLORS = {
  coinbase: '#9333ea',
  alpaca: '#9333ea',
  ibkr: '#9333ea',
  ninjatrader: '#9333ea',
};

export const BENCHMARK_CHART_COLORS = {
  SPY: '#ef4444',
  QQQ: '#3b82f6',
  IEF: '#f97316',
  GLD: '#eab308',
};

export const DEFAULT_CLIENT_REPORTING_CHART_COLORS = {
  ...DEFAULT_BROKER_CHART_COLORS,
  ...BENCHMARK_CHART_COLORS,
};

export const CLIENT_REPORTING_CHART_COLOR_FIELDS = [
  { key: 'coinbase', label: 'Coinbase account line', description: 'Equity curve when viewing a Coinbase account.' },
  { key: 'ibkr', label: 'Interactive Brokers account line', description: 'Equity curve when viewing an IBKR account.' },
  { key: 'alpaca', label: 'Alpaca account line', description: 'Equity curve when viewing an Alpaca account.' },
  { key: 'ninjatrader', label: 'NinjaTrader account line', description: 'Equity curve when viewing a NinjaTrader account.' },
  { key: 'SPY', label: 'SPY benchmark', description: 'S&P 500 comparison line.' },
  { key: 'QQQ', label: 'QQQ benchmark', description: 'Nasdaq-100 comparison line.' },
  { key: 'IEF', label: 'IEF benchmark', description: 'US 7–10Y Treasury comparison line.' },
  { key: 'GLD', label: 'GLD benchmark', description: 'Gold comparison line.' },
];

export function resolveAccountChartColor(chartLineColors, brokerKey) {
  const colors = chartLineColors || DEFAULT_CLIENT_REPORTING_CHART_COLORS;
  const legacyAccount = colors.account;
  // RiskLo palette colors follow the brand theme; colors an admin picked stay as they are.
  if (brokerKey && colors[brokerKey]) return themeColor(colors[brokerKey]);
  if (legacyAccount) return themeColor(legacyAccount);
  if (brokerKey && DEFAULT_BROKER_CHART_COLORS[brokerKey]) {
    return themeColor(DEFAULT_BROKER_CHART_COLORS[brokerKey]);
  }
  return themeColor(ACCOUNT_CHART_COLOR);
}

export function chartColorsToCssVars(colors = DEFAULT_CLIENT_REPORTING_CHART_COLORS, brokerKey = null) {
  return {
    '--cr-account-color': resolveAccountChartColor(colors, brokerKey),
    '--cr-spy-color': colors.SPY ?? BENCHMARK_CHART_COLORS.SPY,
    '--cr-qqq-color': colors.QQQ ?? BENCHMARK_CHART_COLORS.QQQ,
    '--cr-ief-color': colors.IEF ?? BENCHMARK_CHART_COLORS.IEF,
    '--cr-gld-color': colors.GLD ?? BENCHMARK_CHART_COLORS.GLD,
  };
}

export function benchmarkChartSeriesName(benchmark) {
  return benchmark.shortLabel;
}

export function benchmarkById(id) {
  return CLIENT_REPORTING_BENCHMARKS.find((entry) => entry.id === id) || null;
}
